import { Col, Form, Row } from "antd";
import React from "react";
import PageHeader from "../../../components/pageHeader";

function AwaitingLockout() {
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Awaiting Lockout" />
          </Col>
          <Col span={24}>
            <h3>
              Watch for a call from the sheriff for the lockout. when the call
              comes in set up a work order for the vendor to meet them to change
              the locks. at times the vendor can set the time by calling the
              sheriff back.
            </h3>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default AwaitingLockout;
